import { SetGetReplenishment  } from './thunk/setGetReplenishment';
import {SetGetReplenishmentReport} from './thunk/setGetReplenishmentReport';

export const Thunks = {
    SetGetReplenishment,
    SetGetReplenishmentReport
}